import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { CompoApp } from '../../../services/CompoApp';
import { ChecklistTemplateSettingsQueriesAction } from './checklist-template-settings-queries.action';

interface ChecklistTemplateSettingsQueriesStateModel {
 isActionsOpened: boolean
}

const getDefaults = (): ChecklistTemplateSettingsQueriesStateModel => ({
  isActionsOpened : false
});

@State<ChecklistTemplateSettingsQueriesStateModel>({
  name: 'checklistTemplateSettingsQueries',
  defaults: getDefaults()
})
@Injectable()
export class ChecklistTemplateSettingsQueriesXsState {

  private static REQUEST_DELAY: number = 500;

  //region CONSTRUCTOR
  constructor(
    private app: CompoApp,
    private store: Store
  ) {
  }

  @Selector()
  static isActionsOpened(state: ChecklistTemplateSettingsQueriesStateModel): boolean | null {
    return state.isActionsOpened;
  }

  @Action(ChecklistTemplateSettingsQueriesAction.ToggleActions)
  public toggleActions(
    ctx: StateContext<ChecklistTemplateSettingsQueriesStateModel>,
    action: ChecklistTemplateSettingsQueriesAction.ToggleActions
  ): void {
    const state: ChecklistTemplateSettingsQueriesStateModel = ctx.getState();

    ctx.patchState({
      isActionsOpened: action.open
    });
  }
}
